import { useState, useEffect } from 'react';
import axios from 'axios';
import IndustrialProduct from './components/IndustrialProduct';  // Asumiendo que tienes el componente IndustrialProduct
import Navbar from './components/Navbar';
import Footer from './components/Footer';


function Productos() {
    // Estados para almacenar los productos de Industrial y Aire Acondicionado
    const [industrialProducts, setIndustrialProducts] = useState([]);
    const [aireAcondicionado, setAireAcondicionado] = useState([]);

    // Función para obtener los productos de Industrial
    async function obtenerProductosIndustrial() {
        try {
            const respuesta = await axios.get("http://192.168.0.106:4000"); // URL de productos industriales
            setIndustrialProducts(respuesta.data.industrialProducts || []);
           
            
        } catch (error) {
            console.error('Error al obtener productos industriales:', error);
        }
    }

    // Función para obtener los productos de Aire Acondicionado
    async function obtenerProductosAireAcondicionado() {
        try {
            const respuesta = await axios.get("http://192.168.0.106:4000"); // URL de productos de aire acondicionado
            setAireAcondicionado(respuesta.data.aireacondicionados);
        } catch (error) {
            console.error('Error al obtener productos de aire acondicionado:', error);
        }
    }

    // Usar useEffect para obtener los productos cuando el componente se monte
    useEffect(() => {
        obtenerProductosIndustrial();
        obtenerProductosAireAcondicionado();
    }, []);

    return (
        <div className="container mw-100" style={{ backgroundColor: '#ebf7f8' }}>
            <Navbar />
            <br />
            <br />

            <h1 className="text-center text-primary">Productos</h1>

            <div className="container">
                <h3 className="text-center text-primary">Productos Industriales</h3>
                <div className="row row-cols-1 row-cols-md-4 g-4">
                    {industrialProducts?.map((item) => (
                        <IndustrialProduct
                            key={item._id}
                            img={item.imagen}
                            title={item.nombre}
                            id={item._id}
                            details={[
                                { label: "Marca", value: item.marca },
                                { label: "Modelo", value: item.modelo },
                                { label: "Código Producto", value: item.codigoProducto },
                                { label: "Descripción", value: item.descripcion },
                            ]}
                        />
                    ))}
                </div>
            </div>

            <br />
            <hr />
            <div className="container">
                <h3 className="text-center text-primary">Aire Acondicionado</h3>
                <div className="row row-cols-1 row-cols-md-4 g-4">
                    {aireAcondicionado?.map((item) => (
                        <IndustrialProduct
                            key={item._id}
                            img={item.imagen}
                            title={item.nombre}
                            id={item._id}
                            details={[
                                { label: "Marca", value: item.marca },
                                { label: "Modelo", value: item.modelo },
                                { label: "Código Producto", value: item.codigoProducto },
                                { label: "Descripción", value: item.descripcion },
                            ]}
                        />
                    ))}
                </div>
            </div>

            <br />
            <hr />
            <Footer />
            <a href="https://wa.link/8proeq" target="_blank" className="float">
                <i className="bi bi-whatsapp"></i>
            </a>
        </div>
    );
}

export default Productos;
